export default __webpack_public_path__ + "static/media/045-compass.cc62cc9b.png";